<template>
  <div class="StoreTypeTab">
    <div class="flex items-end" style="padding: 15px">
      <div class="input-box box-250">
        <p class="input-label">Quick Reports</p>
        <el-select
          v-model="quickReportsSelected"
          style="width: 100%"
          placeholder="Quick Report"
          @change="commitQuickReports(quickReportsSelected)"
        >
          <el-option
            v-for="(quick_report, index) in allQuickReports"
            :key="index"
            :value="quick_report.id"
            :label="quick_report.name"
            :disabled="
              (selectSalesView == 'labour_hours' && quick_report.id == 'wfr') ||
              (selectSalesView == 'variance' && quick_report.id == 'day') ||
              (selectSalesView == 'variance' && quick_report.id == 'week') ||
              (selectSalesView == 'variance' && quick_report.id == 'month')
            "
          >
            {{ quick_report.name }}
          </el-option>
        </el-select>
        <!-- :disabled="isContributionView &&( quick_report.id == 'day' || quick_report.id == 'week' || quick_report.id == 'month' || quick_report.id == 'wow' || quick_report.id == 'mom')" -->
      </div>
      <div class="input-box box-220">
        <p class="input-label">From</p>
        <el-date-picker
          v-model="dateFrom"
          :disabled="isDatesDisabled"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="Select Date"
          default-value="2010-10-01"
          style="width: 100%"
          :picker-options="datePickerOptions"
          @change="commitDateFrom()"
        />
      </div>
      <div class="input-box box-220">
        <p class="input-label">To</p>
        <el-date-picker
          v-model="dateTo"
          :disabled="isDatesDisabled"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="Select Date"
          style="width: 100%"
          :picker-options="datePickerOptions"
          @change="commitDateTo()"
        />
      </div>
      <div class="input-box box-250">
        <p class="input-label">View</p>
        <el-select
          v-model="selectSalesView"
          style="width: 100%"
          @change="commitSelectSalesView(selectSalesView)"
        >
          <template v-for="(view, index) in allSalesView">
            <el-option
              :key="index"
              :value="view.id"
              :label="view.name"
              :disabled="
                (quickReports == 'wfr' &&
                  (view.name == 'Manpower' || view.name == 'Labour Hours')) ||
                (quickReports != 'wfr' && view.name == 'Variance')
              "
            >
              {{ view.name }}
            </el-option>
          </template>
        </el-select>
      </div>
      <div>
        <el-button
          class="toggle-btn orng-btn"
          style="min-width: 90px; margin-top: 15px; height: 40px"
          @click="goReport()"
          >Go</el-button
        >
      </div>
    </div>

    <div class="mdms">
      <div class="input-box box-300">
        <p class="input-label">Location</p>
        <div class="mdms__parent">
          <base-locations-dropdown @update="dropDownUpdate" />
        </div>
      </div>
      <div v-if="quickReports == 'event'" class="input-box box-250">
        <p class="input-label">Select Year</p>
        <el-select
          v-model="selectYear"
          placeholder="Select Year"
          style="width: 100%"
        >
          <el-option value="2018-2109"> 2018-2109 </el-option>
        </el-select>
      </div>
      <div v-if="quickReports == 'event'" class="input-box box-250">
        <p class="input-label">Event Type</p>
        <el-select
          v-model="eventType"
          placeholder="Select event type"
          style="width: 100%"
        >
          <el-option value="external-event"> External Event </el-option>
        </el-select>
      </div>
      <div v-if="quickReports == 'event'" class="input-box box-250">
        <p class="input-label">Select Event</p>
        <el-select
          v-model="event"
          placeholder="Select event"
          style="width: 100%"
        >
          <el-option value="Sunday 23 Sep 2018 - Ganesh Visarjan">
            Sunday 23 Sep 2018 - Ganesh Visarjan
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import LabourPalnningService from "../../../../services/labourPalnningService";
import { AnalyticsServerAddr, serverAddr } from "../../../../networkConfig";
import { StoreTypeTabNC } from "../../../../../mixins/storeTypeTabNC";
import { EventBus } from "../../../../eventBus";
import axios from "axios";
import { mapState, mapActions } from "vuex";
import BaseLocationsDropdown from "../../../baseLocationsDD/BaseLocationsDD.vue";
import { CommonMixin } from "../../../../../mixins/common.mixin";
import { mapGetters } from "vuex";
import moment from "moment";

const locationBasicsTypes = ["country", "region", "subregion", "outlet"];

export default {
  name: "StoreTypeTab",
  components: {
    BaseLocationsDropdown,
  },
  mixins: [StoreTypeTabNC, CommonMixin],
  props: [],
  data() {
    return {
      dateFrom: moment(
        new Date(new Date().setDate(new Date().getDate() - 1))
      ).format("YYYY-MM-DD"), //set yesterday's date
      dateTo: moment(
        new Date(new Date().setDate(new Date().getDate() - 1))
      ).format("YYYY-MM-DD"), //set yesterday's date
      quickReports: "wfr",
      quickReportsSelected: "wfr",
      selectCategory: [],
      selectSalesView: "iplh",
      selectLocation: "",
      categoryDD: [],
      eventType: "",
      event: "",
      selectYear: "",
      isCategoryInSales: this.$route.name == "Category" ? true : false,
      isLocationInSales: this.$route.name == "Location" ? true : false,
      loc_selected: [],
      cat_selected: [],
      cat_dropdown: [],
      basics: "store_type",
      map: [],
      pageInfo: {
        pageSize: 10,
        currentPage: 1,
      },
      isConsolidated: false,

      isButtonClicked: false,
      previousBasics: "",
      buttonClicked: {},
      whenInCatPageLocBasics: "", // when route is category the basics selected from location dropdown,
      datePickerOptions: {
        disabledDate: this.disabledDueDate,
      },
      basicsInfo: {
        id: "",
        route: this.$route.name,
        basicsFrom: "",
        previousBasics: "",
        currentBasics: "store_type",
      },
      analyticsDataParams: {
        start_date: "",
        end_date: "",
        view: "",
        quickreport: "",
        aggregate: "",
        basics: "store_type",
        filters: { countries: [], regions: [], subregions: [], outlets: [] },
      },
      queryDataParams: {
        start_date: "",
        end_date: "",
        view: "",
        quickreport: "",
        aggregate: "",
        basics: "store_type",
        filters: { countries: [], regions: [], subregions: [], outlets: [] },
      },
      consolidatedDataParams: {
        start_date: "",
        end_date: "",
        view: "",
        quickreport: "",
        aggregate: "",
        basics: null,
        filters: { countries: [], regions: [], subregions: [], outlets: [] },
      },
      locBasicsInCatPage: "",
      allQuickReports: [
        {
          name: "Store type",
          id: "wfr",
          isDisabled: false,
        },
        {
          name: "Daily",
          id: "day",
          isDisabled: false,
        },
        {
          name: "Weekly",
          id: "week",
          isDisabled: false,
        },
        {
          name: "Monthly",
          id: "month",
          isDisabled: false,
        },
        {
          name: "Week To Date",
          id: "wtd",
          isDisabled: false,
        },
        {
          name: "Month To Date",
          id: "mtd",
          isDisabled: false,
        },
        {
          name: "Quarter To Date",
          id: "qtd",
          isDisabled: false,
        },
        {
          name: "Year To Date",
          id: "ytd",
        },
      ],
      allSalesView: [
        {
          name: "IPLH",
          id: "iplh",
          isVisible: true,
        },
        {
          name: "Variance",
          id: "variance",
          isVisible: true,
        },
        {
          name: "TPLH",
          id: "tplh",
          isVisible: true,
        },
        // {
        // 	name: "Manpower",
        // 	id: "manpower",
        // 	isVisible: true
        // },
        // {
        // 	name: "Labour Hours",
        // 	id: "labour_hours",
        // 	isVisible: true
        // }
      ],
      responseMetaField: {},
      stored_breadCrumbs: [],
      temp: [],
      storeMappings: [],
      outlet_ids: [],
      companyData: {},
    };
  },
  created() {
    this.$emit("handler", this.setValue);
    this.getFinancialYear();
  },
  computed: {
    ...mapState("CommonStore", ["tablePageCount", "locations", "categories"]),
    ...mapGetters(["getAnalyticsData", "getIsOutletClickedFromTable"]),

    isCategoryPage() {
      return this.$route.name == "Category";
    },

    isLocationPage() {
      return this.$route.name == "Location";
    },

    isDatesDisabled() {
      return (
        this.quickReportsSelected == "wtd" ||
        this.quickReportsSelected == "mtd" ||
        this.quickReportsSelected == "qtd" ||
        this.quickReportsSelected == "ytd"
      );
    },

    filterLocIds() {
      return this.loc_selected.map((obj) => obj.id);
    },

    filterCatIds() {
      return this.cat_selected.map((obj) => obj.id);
    },
  },
  mounted() {
    this.$store.commit('CommonStore/QUICK_REPORT_LABEL', this.selectSalesView)
    this.$store.commit('CommonStore/SHOW_LABOUR_DATA', false);
    // get value added for csv name on report table
    localStorage.setItem("dateRange", `${this.dateFrom} To ${this.dateTo}`);
    EventBus.$on("buttonClickedEvent", this.buttonClickedFn);
    EventBus.$on("clickBreadcurmbReportEvent", this.breadCurmbClickable);
    EventBus.$on("clickToShowInitialReportData", this.showInitialData);
    EventBus.$on("pageInfoChangeSalesEvent", this.handlePageInfoChange);
    this.$store.commit("setselectSalesView", this.selectSalesView);
    this.$store.commit("setLocBasis", this.basics);
    this.$store.commit("setCatBasics", this.cat_basics);
    this.$store.commit("setQuickReports", this.quickReports);

    if (!this.getIsOutletClickedFromTable) {
      this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);
      this.getAnalyticsReportData(); //function to call api for analytics and consolidate data
      // only don't call this function when outlet button is clicked on table row
    }

    EventBus.$on("downloadCsvReport", this.getOptionsSelectedBySales);
    EventBus.$on("breadCrumbs", (data) => {
      this.stored_breadCrumbs = data;
    });
  },
  beforeDestroy() {
    EventBus.$off("pageInfoChangeSalesEvent", this.handlePageInfoChange);
    EventBus.$off("buttonClickedEvent", this.buttonClickedFn);
    EventBus.$off("clickBreadcurmbReportEvent", this.breadCurmbClickable);
    EventBus.$off("clickToShowInitialReportData", this.showInitialData);
    EventBus.$off("downloadCsvReport", this.getOptionsSelectedBySales);
  },
  methods: {
    setValue(value) {
      this.value = value;
      this.handlePageInfoChange(value);
      console.log("value", value);
    },
    getFinancialYear() {
      LabourPalnningService.getCompanyData()
        .then((response) => {
          this.companyData = JSON.parse(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    queryObject(result, isConsolidated) {
      this.isConsolidated = isConsolidated;
      this.basics = result.currentBasics;
      if (
        this.quickReports == "day" ||
        this.quickReports == "week" ||
        this.quickReports == "month"
      ) {
        return {
          start_date: this.dateFrom,
          end_date: this.dateTo,
          view: this.selectSalesView,
          quickreport: this.quickReports,
          aggregate: this.quickReports,
          basics: this.isConsolidated ? null : this.basics,
          filters: this.getAllFilters(this.isConsolidated, result),
        };
      } else {
        return {
          start_date: this.dateFrom,
          end_date: this.dateTo,
          view: this.selectSalesView,
          quickreport: this.quickReports,
          basics: this.isConsolidated ? null : this.basics,
          filters: this.getAllFilters(this.isConsolidated, result),
        };
      }
      // get value added for csv name on report table
      localStorage.setItem("dateRange", `${this.dateFrom} To ${this.dateTo}`);
    },

    async breadCurmbClickable(selected_bredcrumb, element) {
      this.loc_selected = [element[0]];

      // ******************set queryObject of current clickabled breadcurmb**********************************
      for (var i in this.stored_breadCrumbs) {
        for (var key in this.stored_breadCrumbs[i]) {
          if (key == selected_bredcrumb) {
            // *******************Removed next clickable breadCurmb************************************
            this.stored_breadCrumbs.splice(
              Number(i) + 1,
              this.stored_breadCrumbs.length - 1
            );
          }
        }
      }
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
      this.basicsInfo = element[1]; // setting this.bascisInfo

      if (this.quickReports == "wfr") {
        this.getAnalyticsReportData();
      } else {
        this.getQueryReportData();
        // let reportsDataResponse = await this.getQueryData(
        // 	this.queryObject(this.basicsInfo, false),
        // 	false
        // );
        // this.getQueryReportsNetworkCallBack(reportsDataResponse); //passed response to getReportCallBack
      }
    },

    async dropDownUpdate(update) {
      this.loc_selected = update.selected;
      if (
        this.isCategoryPage &&
        locationBasicsTypes.indexOf(update.basics) > 0
      ) {
        this.locBasicsInCatPage = update.basics;
      } else {
        this.basicsInfo = this.getBasics(update.basics, update.id, "dropdown");
      }

      this.resetPageInfo();
      if (this.quickReports == "wfr") {
        console.log("update", this.filterLocIds);

        if (
          this.loc_selected.length &&
          this.loc_selected[0].type == "country"
        ) {
          this.analyticsDataParams.filters.countries = this.filterLocIds;
          this.analyticsDataParams.filters.regions = [];
          this.analyticsDataParams.filters.subregions = [];
        } else if (
          this.loc_selected.length &&
          this.loc_selected[0].type == "region"
        ) {
          this.analyticsDataParams.filters.regions = this.filterLocIds;
          this.analyticsDataParams.filters.countries = [];
          this.analyticsDataParams.filters.subregions = [];
        } else if (
          this.loc_selected.length &&
          this.loc_selected[0].type == "subregion"
        ) {
          this.analyticsDataParams.filters.subregions = this.filterLocIds;
          this.analyticsDataParams.filters.countries = [];
          this.analyticsDataParams.filters.regions = [];
        }

        // this.analyticsDataParams.filters = {
        // 	countries: [],
        // 	regions: [],
        // 	subregions: [],
        // 	outlets: []
        // };

        this.getAnalyticsReportData();
      } else {
        this.queryDataParams.filters = {
          countries: [],
          regions: [],
          subregions: [],
          outlets: [],
        };

        this.getQueryReportData();
        // let reportsDataResponse = await this.getQueryData(
        // 	this.queryObject(this.basicsInfo, false),
        // 	false
        // );
        // this.getQueryReportsNetworkCallBack(reportsDataResponse); //passed response to getReportCallBack
      }
      // get value added for csv name on report table
      localStorage.setItem("dateRange", `${this.dateFrom} To ${this.dateTo}`);
    },

    storeBreadcurmb(element) {
      var temp = [];
      temp.push(element);
      temp.push(this.basicsInfo);
      if (this.stored_breadCrumbs.length) {
        if (!this.lookup(element.label, this.stored_breadCrumbs)) {
          this.stored_breadCrumbs.push({
            [element.label]: temp,
          });
        }
      } else {
        this.stored_breadCrumbs.push({
          [element.label]: temp,
        });
      }
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
    },

    async buttonClickedFn(element) {
      if (element.label == "Consolidated") {
        return;
      }

      EventBus.$emit("activeBreadCrumb", element.label);

      if (this.isLocationPage || this.$route.name === "Report") {
        this.loc_selected = [element];
      }

      if (this.isCategoryPage) {
        this.cat_selected = [element];
      }

      this.basicsInfo = this.getBasics(this.basics, element.id, "table");
      this.resetPageInfo();

      if (this.quickReports == "wfr") {
        let selectedStoreTypes = [];
        var storeTypeNameRes = await this.getStoreTypeName();
        storeTypeNameRes.forEach((e) => {
          if (element.label == e.store_type) {
            selectedStoreTypes.push(e.id);
          }
        });

        this.storeMappings = await this.getOutletsMapping(selectedStoreTypes);

        this.analyticsDataParams.filters = {
          countries: [],
          regions: [],
          subregions: [],
          outlets: [],
        };

        this.analyticsDataParams.filters.outlets = selectedStoreTypes;
        this.analyticsDataParams.basics = "outlet";

        // to disabled row click set basics
        this.basics = this.analyticsDataParams.basics;

        this.getAnalyticsReportData();
      } else {
        this.getQueryReportData();
      }
      this.storeBreadcurmb(element);
    },

    async commitDateFrom() {
      if (
        this.dateFrom &&
        this.dateTo &&
        this.quickReports &&
        this.selectSalesView
      ) {
        //function to fill table headers as per quick reports and view type
        this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);

        this.$store.commit("setDateFrom", this.dateTo);
        this.resetPageInfo();
        if (!this.basicsInfo.currentBasics) {
          this.basicsInfo.currentBasics = this.basics;
        }

        if (this.quickReports == "wfr") {
          this.analyticsDataParams.basics = "store_type";
          this.getAnalyticsReportData();
        } else {
          this.getQueryReportData();
        }
      }
      // get value added for csv name on report table
      localStorage.setItem("dateRange", `${this.dateFrom} To ${this.dateTo}`);
    },

    commitDateTo() {
      // if (
      // 	this.dateFrom &&
      // 	this.dateTo &&
      // 	this.quickReports &&
      // 	this.selectSalesView
      // ) {
      // 	//function to fill table headers as per quick reports and view type
      // 	this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);

      // 	this.$store.commit("setDateTo", this.dateFrom);
      // 	this.resetPageInfo();
      // 	if (!this.basicsInfo.currentBasics) {
      // 		this.basicsInfo.currentBasics = this.basics;
      // 	}

      // 	if (this.quickReports == "wfr") {
      // 		this.analyticsDataParams.basics = "store_type";
      // 		this.getAnalyticsReportData();
      // 	} else {
      // 		this.getQueryReportData();
      // 	}
      // }
      // get value added for csv name on report table
      localStorage.setItem("dateRange", `${this.dateFrom} To ${this.dateTo}`);
    },
    async goReport() {
      if (
        this.dateFrom &&
        this.dateTo &&
        this.quickReports &&
        this.selectSalesView
      ) {
        //function to fill table headers as per quick reports and view type
        this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);

        this.$store.commit("setselectSalesView", this.selectSalesView);
        this.resetPageInfo();

        if (this.quickReports == "wfr") {
          this.analyticsDataParams.basics = "store_type";
          this.getAnalyticsReportData();
        } else {
          this.getQueryReportData();
        }
      }
    },

    commitQuickReports(reportType) {
      if (reportType == "wtd") {
        let d = new Date();
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        this.dateFrom = moment(new Date(d.setDate(diff))).format("YYYY-MM-DD");
        reportType = "wfr";
        this.quickReports = "wfr";
      } else if (reportType == "mtd") {
        let date = new Date(),
          y = date.getFullYear(),
          m = date.getMonth();
        let firstDay = new Date(y, m, 1); //get month start date
        this.dateFrom = moment(new Date(firstDay)).format("YYYY-MM-DD");
        reportType = "wfr";
        this.quickReports = "wfr";
      } else if (reportType == "qtd") {
        var quarter = Math.floor(new Date().getMonth() / 3); // get quarter in year
        var firstDay = new Date(new Date().getFullYear(), quarter * 3, 1); // get date in quater frist date
        this.dateFrom = moment(new Date(firstDay)).format("YYYY-MM-DD");
        reportType = "wfr";
        this.quickReports = "wfr";
      } else if (reportType == "ytd") {
        let today = new Date();
        console.log(today.getMonth() + 1);
        if (today.getMonth() + 1 <= 3) {
          this.dateFrom = `${today.getFullYear() - 1}-04-01`;
        } else {
          this.dateFrom = `${today.getFullYear()}-04-01`;
        }
        reportType = "wfr";
        this.quickReports = "wfr";
      } else {
        this.quickReports = reportType;
      }
      // if (
      // 	this.dateFrom &&
      // 	this.dateTo &&
      // 	this.quickReports &&
      // 	this.selectSalesView
      // ) {
      // 	//function to fill table headers as per quick reports and view type
      // 	this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);

      // 	this.$store.commit("setQuickReports", this.quickReports);
      // 	this.resetPageInfo();

      // 	if (reportType == "wfr") {
      // 		this.analyticsDataParams.filters = {};
      // 		this.analyticsDataParams.basics = "store_type";
      // 		this.getAnalyticsReportData();
      // 	} else {
      // 		this.getQueryReportData();
      // 	}
      // }
      // get value added for csv name on report table
      localStorage.setItem("dateRange", `${this.dateFrom} To ${this.dateTo}`);
    },

    commitSelectSalesView() {
      // if (
      // 	this.dateFrom &&
      // 	this.dateTo &&
      // 	this.quickReports &&
      // 	this.selectSalesView
      // ) {
      // 	//function to fill table headers as per quick reports and view type
      // 	this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);
      // 	this.$store.commit("setselectSalesView", this.selectSalesView);
      // 	this.resetPageInfo();
      // 	if (this.quickReports == "wfr") {
      // 		this.analyticsDataParams.basics = "store_type";
      // 		this.getAnalyticsReportData();
      // 	} else {
      // 		this.getQueryReportData();
      // 	}
      // }
    },

    fillHeadersOfReportTable(reportsType, viewType) {
      this.mainHeadings = [];
      this.subHeadings = [];
      this.csvSubHeadings = [];
      let mainHeadings = [];
      let subHeadings = [];
      let csvSubHeadings = [];
      if (reportsType == "wfr" && viewType == "iplh") {
        mainHeadings = [
          { value: "", colspan: 1, isBorderBottomRequired: false },
          { value: "Ideal", colspan: 2, isBorderBottomRequired: true },
          { value: "Scheduled", colspan: 2, isBorderBottomRequired: true },
          { value: "Actual", colspan: 2, isBorderBottomRequired: true },
          { value: "Difference(%)", colspan: 2, isBorderBottomRequired: true },
        ];

        subHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "IPLH", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "IPLH", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "IPLH", colspan: 1, isBorder: true },
          { value: "Actual vs Forecast", colspan: 1, isBorder: true },
          { value: "Actual vs Scheduled", colspan: 1, isBorder: true },
        ];

        csvSubHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Actual Labour Hours", colspan: 1, isBorder: true },
          { value: "Actual IPLH", colspan: 1, isBorder: true },
          { value: "Forecast Labour Hours", colspan: 1, isBorder: true },
          { value: "Forecast IPLH", colspan: 1, isBorder: true },
          { value: "Scheduled Labour Hours", colspan: 1, isBorder: true },
          { value: "Scheduled IPLH", colspan: 1, isBorder: true },
          {
            value: "Difference Actual vs Forecast",
            colspan: 1,
            isBorder: true,
          },
          {
            value: "Difference Actual vs Scheduled",
            colspan: 1,
            isBorder: true,
          },
        ];
      } else if (reportsType == "wfr" && viewType == "manpower") {
        mainHeadings = [
          { value: "", colspan: 1, isBorderBottomRequired: false },
          { value: "Achievement", colspan: 3, isBorderBottomRequired: true },
          { value: "Target", colspan: 3, isBorderBottomRequired: true },
          { value: "(Difference%)", colspan: 4, isBorderBottomRequired: true },
        ];

        subHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "ADT", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "Manpower", colspan: 1, isBorder: true },
          { value: "ADT", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "Manpower", colspan: 1, isBorder: true },
          { value: "", colspan: 1, isBorder: true },
          { value: "", colspan: 1, isBorder: true },
          { value: "", colspan: 1, isBorder: true },
        ];

        csvSubHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Achievement ADT", colspan: 1, isBorder: true },
          { value: "Achievement Labour Hours", colspan: 1, isBorder: true },
          { value: "Achievement Manpower", colspan: 1, isBorder: true },
          { value: "Target ADT", colspan: 1, isBorder: true },
          { value: "Target Labour Hours", colspan: 1, isBorder: true },
          { value: "Target Manpower", colspan: 1, isBorder: true },
          { value: "Difference", colspan: 1, isBorder: true },
          { value: "Difference", colspan: 1, isBorder: true },
          { value: "Difference", colspan: 1, isBorder: true },
        ];
      } else if (reportsType == "wfr" && viewType == "variance") {
        mainHeadings = [
          { value: "", colspan: 1, isBorderBottomRequired: false },
          { value: "Ideal", colspan: 1, isBorderBottomRequired: true },
          { value: "Scheduled", colspan: 1, isBorderBottomRequired: true },
          { value: "Actual", colspan: 1, isBorderBottomRequired: true },
          { value: "Wastage Hours", colspan: 1, isBorderBottomRequired: true },
          { value: "Variance", colspan: 2, isBorderBottomRequired: true },
        ];

        subHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "Forecast/Actual", colspan: 1, isBorder: true },
          { value: "Business Hours", colspan: 1, isBorder: true },
          { value: "Total Hours", colspan: 1, isBorder: true },
        ];
        csvSubHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Actual Labour Hours", colspan: 1, isBorder: true },
          { value: "Forecast Labour Hours", colspan: 1, isBorder: true },
          { value: "Scheduled Labour Hours", colspan: 1, isBorder: true },
          {
            value: "Wastage Hours Forecast/Actual",
            colspan: 1,
            isBorder: true,
          },
          { value: "Variance Business Hours", colspan: 1, isBorder: true },
          { value: "Variance Total Hours", colspan: 1, isBorder: true },
        ];
      } else if (reportsType == "wfr" && viewType == "tplh") {
        mainHeadings = [
          { value: "", colspan: 1, isBorderBottomRequired: false },
          { value: "Ideal", colspan: 3, isBorderBottomRequired: true },
          { value: "Scheduled", colspan: 3, isBorderBottomRequired: true },
          { value: "Actual", colspan: 3, isBorderBottomRequired: true },
          { value: "Difference(%)", colspan: 1, isBorderBottomRequired: true },
        ];

        subHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Txns.", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "TPLH", colspan: 1, isBorder: true },
          { value: "Txns.", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "TPLH", colspan: 1, isBorder: true },
          { value: "Txns.", colspan: 1, isBorder: true },
          { value: "Labour Hours", colspan: 1, isBorder: true },
          { value: "TPLH", colspan: 1, isBorder: true },
          { value: "Actual vs Forecast", colspan: 1, isBorder: true },
        ];

        csvSubHeadings = [
          { value: "Store Name", colspan: 1, isBorder: true },
          { value: "Actual Txns.", colspan: 1, isBorder: true },
          { value: "Actual Labour Hours", colspan: 1, isBorder: true },
          { value: "Actual TPLH", colspan: 1, isBorder: true },
          { value: "Forecast Txns.", colspan: 1, isBorder: true },
          { value: "Forecast Labour Hours", colspan: 1, isBorder: true },
          { value: "Forecast TPLH", colspan: 1, isBorder: true },
          { value: "Scheduled Txns.", colspan: 1, isBorder: true },
          { value: "Scheduled Labour Hours", colspan: 1, isBorder: true },
          { value: "Scheduled TPLH", colspan: 1, isBorder: true },
          {
            value: "Difference Actual vs Forecast",
            colspan: 1,
            isBorder: true,
          },
        ];
      }

      this.tableData.data.mainHeadings = mainHeadings;
      this.tableData.data.subHeadings = subHeadings;
      this.tableData.data.csvSubHeadings = csvSubHeadings;
    },

    commitSelectLocation(payload) {
      this.$store.commit("setSelectLocation", payload);
      this.resetPageInfo();
      this.combinationOfConsolidatedAndAnalytics(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    // on page load called these two apis 1 for analytics data and 1 for consolidated data
    //after getting response passed to function AnalyticsDataCallBack written in reportTabNC.js
    async getAnalyticsReportData() {
      this.analyticsDataParams.start_date = this.dateFrom;
      this.analyticsDataParams.end_date = this.dateTo;
      this.analyticsDataParams.view = this.selectSalesView;
      this.analyticsDataParams.aggregate = "";
      this.analyticsDataParams.quickreport = this.quickReports;

      let analyticsDataResponse = await this.AnalyticsData(
        this.analyticsDataParams
      );

      this.consolidatedDataParams.start_date = this.dateFrom;
      this.consolidatedDataParams.end_date = this.dateTo;
      this.consolidatedDataParams.view = this.selectSalesView;
      this.consolidatedDataParams.aggregate = "";
      this.consolidatedDataParams.quickreport = this.quickReports;

      let consolidatedDataResponse = await this.getConsolidatedData(
        this.consolidatedDataParams
      );

      this.AnalyticsDataCallBack(
        analyticsDataResponse.results
          ? analyticsDataResponse.results
          : analyticsDataResponse,
        consolidatedDataResponse.results
          ? consolidatedDataResponse.results
          : consolidatedDataResponse
      );
    },

    async getQueryReportData() {
      this.queryDataParams.start_date = this.dateFrom;
      this.queryDataParams.end_date = this.dateTo;
      this.queryDataParams.view = this.selectSalesView;
      this.queryDataParams.aggregate = this.quickReports;
      this.queryDataParams.quickreport = this.quickReports;
      this.queryDataParams.basics = "store_type";

      let queryResponse1 = await this.getQueryData(this.queryDataParams, false);

      this.queryDataParams.start_date = this.dateFrom;
      this.queryDataParams.end_date = this.dateTo;
      this.queryDataParams.view = this.selectSalesView;
      this.queryDataParams.aggregate = this.quickReports;
      this.queryDataParams.basics = null;

      let queryResponse2 = await this.getQueryData(this.queryDataParams, true);

      this.getQueryReportsNetworkCallBack(queryResponse1, queryResponse2); //passed response to getReportCallBack
    },

    // api to get analytics data
    AnalyticsData(queryObject) {
      return serverAddr
        .post(
          `/sheduling/reports/analytics/?page=${this.pageInfo.currentPage}&page_size=${this.pageInfo.pageSize}`,
          queryObject
        )
        .then((response) => {
          if (response.status == 200) {
            this.$store.commit(
              "CommonStore/TABLE_PAGE_COUNT",
              JSON.parse(response.data).count
            );
            return JSON.parse(response.data);
          } else {
            return [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //api to get consolidated data
    getConsolidatedData(queryObject) {
      return serverAddr
        .post(`/sheduling/reports/analytics/`, queryObject)
        .then(function (response) {
          if (response.status == 200) {
            return JSON.parse(response.data);
          } else {
            return [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //api to get reports data query api
    getQueryData(queryObject, isConsolidated) {
      var url = isConsolidated
        ? "sheduling/reports/query/"
        : `sheduling/reports/query/?page=${this.pageInfo.currentPage}&page_size=${this.pageInfo.pageSize}`;
      return serverAddr
        .post(url, queryObject)
        .then((response) => {
          if (response.status == 200) {
            if (!isConsolidated) {
              this.$store.commit(
                "CommonStore/TABLE_PAGE_COUNT",
                JSON.parse(response.data).count
              );
            }
            return JSON.parse(response.data);
          } else {
            this.$store.commit("setAnalyticsData", {});
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //api to get outlets mappings - outlets name from outlets ids
    getOutletsMapping(outletsIds) {
      return serverAddr
        .post("/common/name-mapping/", {
          basics: "outlet",
          id_list: outletsIds,
        })
        .then((response) => {
          if (response.status == 200) {
            return JSON.parse(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //api to get store type name data
    getStoreTypeName() {
      return serverAddr
        .get("/outlet/?get_all=true")
        .then((response) => {
          if (response.status == 200) {
            return JSON.parse(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    combinationOfConsolidatedAndAnalytics(
      analyticsQueryObject,
      consolidatedQueryObject,
      pageInfo
    ) {
      axios
        .all([
          this.AnalyticsData(analyticsQueryObject, pageInfo),
          this.getConsolidatedData(consolidatedQueryObject),
        ])
        .then(
          axios.spread((tableData, consolidatedTableData) => {
            EventBus.$emit("disableFirstButton", false);
            this.AnalyticsDataCallBack(tableData, consolidatedTableData);
            this.isButtonClicked = false;
            this.$store.commit("IS_OUTLET_CLIKED_FROM_TABLE", false);

            this.cat_selected = [];
          })
        )
        .catch((error) => {
          EventBus.$emit("disableFirstButton", false);
          console.log(error);
        });
    },

    resetPageInfo() {
      EventBus.$emit("resetPageInfoEvent");
      this.pageInfo.pageSize = 10;
      this.pageInfo.currentPage = 1;
    },

    handlePageInfoChange(pageInfo) {
      this.pageInfo.pageSize = pageInfo.pageSize;
      this.pageInfo.currentPage = pageInfo.currentPage;
      if (
        this.quickReports == "day" ||
        this.quickReports == "week" ||
        this.quickReports == "month"
      ) {
        this.getQueryReportData();
      } else {
        this.combinationOfConsolidatedAndAnalytics(
          this.queryObject(this.basicsInfo, false),
          this.queryObject(this.basicsInfo, true),
          this.pageInfo
        );
      }
    },

    handleCurrentPageChange(currentPage) {
      this.pageInfo.currentPage = currentPage;
      this.combinationOfConsolidatedAndAnalytics(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    getOptionsSelectedBySales() {
      var idNameMap = this.getIdNameMap(this.locations);
      var locations_name, categories_name;
      // ******************Location name mapping*****************************
      locations_name = this.filterLocIds.map((id) => {
        for (var i = 0; i < idNameMap.length; i++) {
          if (idNameMap[i].id == id) {
            return idNameMap[i].name;
          }
        }
      });
      // ******************Quick report & view, name mapping*****************************
      var selected_qr, selected_sv;
      for (var x in this.allQuickReports) {
        if (this.allQuickReports[x].id == this.quickReports) {
          selected_qr = this.allQuickReports[x].name;
        }
      }
      for (var x in this.allSalesView) {
        if (this.allSalesView[x].id == this.selectSalesView) {
          selected_sv = this.allSalesView[x].name;
        }
      }
      // ******************set object for download csv*****************************
      var selectedObjSaleByLocation = {
        "Quick Reports": selected_qr,
        "Sales View": selected_sv,
        "Date From": this.dateFrom,
        "Date To": this.dateTo,
        Locations: locations_name.toString(),
      };
      // ******************set object with category for download csv*****************************
      if (this.$route.name == "Category") {
        if (this.filterCatIds.length > 0) {
          var idNameCatMap = [];
          this.categories.map((obj) => {
            idNameCatMap.push({
              name: obj.name,
              id: obj.id,
            });
          });
          categories_name = this.filterCatIds.map((id) => {
            for (var i = 0; i < idNameCatMap.length; i++) {
              if (idNameCatMap[i].id == id) {
                return idNameCatMap[i].name;
              }
            }
          });
          selectedObjSaleByLocation.Categories = categories_name.toString();
        }
      }
      return this.downloadCsvReport(
        this.$route.name,
        selectedObjSaleByLocation,
        this.getAnalyticsData
      );
    },
    getAllMondayFromYear(time) {
      var d = new Date(time),
        year = d.getYear(),
        mondays = [];
      if (d < new Date()) {
        d.setDate(1);
        // Get the first Monday in the month
        while (d.getDay() !== 1) {
          d.setDate(d.getDate() + 1);
        }

        // Get all the other Mondays in the month
        while (d.getYear() === year) {
          var pushDate = new Date(d.getTime());
          mondays.push(moment(pushDate).format("YYYY-MM-DD"));
          d.setDate(d.getDate() + 7);
        }
      }
      return mondays;
    },
    disabledDueDate(time) {
      if (this.quickReports == "week") {
        var mondays = this.getAllMondayFromYear(time);
        return !mondays.includes(moment(time).format("YYYY-MM-DD"));
      } else if (this.quickReports == "month") {
        var first_date = new Date(time),
          year = first_date.getYear(),
          mondays = [];
        first_date.setDate(1);
        var now = new Date();
        var next_month_firstDate = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          1
        );
        if (next_month_firstDate > first_date) {
          if (new Date(1).getDate() != time.getDate()) {
            return time.getTime();
          }
        } else {
          return time.getTime();
        }
      } else {
        return time.getTime() > Date.now() - 8.64e7;
      }
    },
    showInitialData() {
      if (!this.getIsOutletClickedFromTable) {
        this.fillHeadersOfReportTable(this.quickReports, this.selectSalesView);
        this.getAnalyticsReportData(); //function to call api for analytics and consolidate data
      }
      this.stored_breadCrumbs = []; //clear all breadcurmbs
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./StoreTypeTab.scss";
@import "../../../../assets/css/variable.scss";
</style>
<style>
.StoreTypeTab {
  margin: 0.5rem 0;
  border-radius: 4px;
}
.StoreTypeTab .el-select > .el-input {
  margin-right: 5px;
}
.StoreTypeTab .el-menu.el-menu--horizontal {
  border-bottom-color: 1px solid #c8c8c8 !important;
}
.StoreTypeTab .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 39px;
  line-height: 42px;
  border: 1px solid #c8c8c8;
  color: #909399;
  border-radius: 4px !important;
}
.StoreTypeTab .BaseLocationsDropdown {
  width: 100%;
}
.toggle-btn {
  background-color: #e29d5a;
  color: #fff;
}
</style>
